import { ArrowUpRight, Globe, Mail, MessageCircle, Phone } from "lucide-react";
import { EMAIL, PHONE, PHONE_DISPLAY, SITE_URL } from "@/lib/contact";

const ACTIONS = [
    {
        id: "contact-call-link",
        icon: Phone,
        label: "Telefono",
        value: PHONE_DISPLAY,
        href: `tel:${PHONE}`,
    },
    {
        id: "contact-whatsapp-link",
        icon: MessageCircle,
        label: "WhatsApp",
        value: "Scrivimi direttamente",
        href: `https://wa.me/${PHONE.replace("+", "")}?text=${encodeURIComponent("Ciao Mino, ho scansionato il tuo biglietto digitale!")}`,
    },
    {
        id: "contact-email-link",
        icon: Mail,
        label: "Email",
        value: EMAIL,
        href: `mailto:${EMAIL}`,
    },
    {
        id: "website-link",
        icon: Globe,
        label: "Sito web",
        value: "minocesari.com",
        href: SITE_URL,
    },
];

export const ContactActions = () => (
    <div className="flex flex-col gap-3">
        {ACTIONS.map(({ id, icon: Icon, label, value, href }) => (
            <a
                key={id}
                data-testid={id}
                href={href}
                target={href.startsWith("http") ? "_blank" : undefined}
                rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                className="glass group flex items-center gap-4 rounded-xl border border-[rgba(226,192,117,0.16)] px-5 py-4 transition-colors duration-300 hover:border-[rgba(226,192,117,0.45)]"
            >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[rgba(226,192,117,0.3)] text-[#e2c075] transition-colors duration-300 group-hover:bg-[#e2c075] group-hover:text-[#090a0c]">
                    <Icon className="h-4 w-4" />
                </span>
                <span className="flex min-w-0 flex-1 flex-col">
                    <span className="font-code text-[10px] uppercase tracking-[0.25em] text-[#686f7c]">
                        {label}
                    </span>
                    <span className="truncate text-sm font-medium text-[#f4f1ea]">{value}</span>
                </span>
                <ArrowUpRight className="h-4 w-4 shrink-0 text-[#686f7c] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#e2c075]" />
            </a>
        ))}
    </div>
);
